module.exports = __webpack_public_path__ + "static/img/Bachelor_010265.2dc3172.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010265.jpg
// module id = 133
// module chunks = 0